import React from 'react';
import { withRouter } from 'react-router-dom';
import AIMainController from './AIMainController';

const AIMainLoader = (props) => {
  return <AIMainController>{props.children}</AIMainController>;
};

export default withRouter(AIMainLoader);
